import { put, takeLatest } from 'redux-saga/effects';

import { getGeoData } from '../../services/geo.service';

import { setGeoDataSuccess, setGeoDataFailure } from './geo.actions';

import GeoActionTypes from './geo.types';

function* setGeoDataStart() {
  try {
    const data = yield getGeoData();
    yield put(setGeoDataSuccess(data));
  } catch (error) {
    yield put(setGeoDataFailure(error));
  }
}

export default function* geoSagas() {
  yield takeLatest(GeoActionTypes.SET_GEO_DATA_START, setGeoDataStart);
}
